export enum AccountingBookType {
Level1,
Level2,
Level3,
Nothing,
}
